"use client";

import { Facebook, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground/70 hover:text-foreground transition-colors duration-[var(--duration-medium)]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    id: "facebook",
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    id: "linkedin",
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    id: "twitter",
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }];
  return <footer ref={ref} className={`w-full bg-light-background border-t border-border py-6 transition-opacity duration-[var(--duration-slow)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {}
          <div className="text-sm text-foreground/60">
            © {currentYear} Haven Holdings Capital. All rights reserved.
          </div>

          {}
          <MenuProvider menu_id="4" className="footer-navigation">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.id} to={social.href} newTab aria-label={social.label} data-index={i} className="text-foreground/60 hover:text-foreground transition-all duration-[var(--duration-medium)] hover:scale-110 animate-pulse hover:animate-none">
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </footer>;
}